import * as React from 'react';

import '../../assets/style.css';
import Footer from '../../components/footer/Footer';
import CheckBox from '../../components/formElements/CheckBox';
import { makeFormControls, validateForm } from '../../components/formElements/util';
import { isEmail, isEmpty } from '../../components/formElements/validators';
import Form from '../../components/formElements/Form';
import Table from '../../components/table/Table';
import Modal from '../../components/modal/Modal';

import axios from 'axios';
import Navbar from '../../components/nav/Navbar';

import { api } from '../../environment';
import PresentationForm from '../../components/forms/PresentationForm';

import {isBrowser, isMobile } from 'react-device-detect';

export default function AbstractApp(){

   return (
        <>
        <Navbar/>

            <div className="flex-column background-opaque" style={{paddingTop:"30vh",gap:"4rem", width:"100%"}}>
            <div><h1 className="section-title-font" style={{color:"black", fontWeight:"400", fontSize:isMobile?"2rem":"3.5rem", textAlign:"center"}}><span className="">Prijava</span> sažetaka</h1>
		<div style={{textAlign:"left", margin:"auto", width:isMobile?"100%":"50%", padding:isMobile?"1em":"0em"}}>
		    <h2> Prijave sažetaka su zaključane. </h2>

		</div>
	    </div>
	    
		
            </div>
        <Footer/>
        </>
    )


}
